export const initialState = {
  utils: {
    loading: false,
    alertMessage: ""
  }
};
